import { render, staticRenderFns } from "./PagedListRoutes.vue?vue&type=template&id=13cbf1fa&"
import script from "./PagedListRoutes.vue?vue&type=script&lang=js&"
export * from "./PagedListRoutes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports